export class CustomError extends Error {
    constructor(pMessage) {
        super(pMessage);
        Object.setPrototypeOf(this, CustomError.prototype);
    }
    //override name property, returns class name as default
    get name() {
        return (this.mCustomName != null ? this.mCustomName : this.constructor.name);
    }
    set name(pName) {
        this.mCustomName = pName;
    }
}
export default CustomError;
